export default __webpack_public_path__ + "static/media/other.f463a804.jpg";